import { Layout, Menu } from "antd";
import { StarOutlined, SettingOutlined } from "@ant-design/icons";
import { NavLink, useLocation } from "react-router-dom";

const { Sider } = Layout;

const Sidebar = () => {
  const location = useLocation();

  const menuItems = [
    // {
    //   key: "/reputation-manager",
    //   icon: <HomeOutlined />,
    //   label: <NavLink to="/reputation-manager">Dashboard</NavLink>,
    // },
    {
      key: "/reputation-manager/reviews",
      icon: <StarOutlined />,
      label: <NavLink to="/reputation-manager/reviews">Reviews</NavLink>,
    },
    {
      key: "/reputation-manager/settings",
      icon: <SettingOutlined />,
      label: <NavLink to="/reputation-manager/settings">Settings</NavLink>,
    },
  ];

  return (
    <Sider className="sidebar padd-90">
      <Menu
        mode="inline"
        selectedKeys={[location.pathname]}
        style={{
          height: "100%",
          borderRight: 0,
        }}
        items={menuItems}
        className="bg-theme text-white"
      />
    </Sider>
  );
};

export default Sidebar;
